<template>
  <div class="d-none d-md-block navbar-class" ref="navbar">
    <v-container fluid>
      <div class="d-flex align-center justify-space-between">
        <v-list-item>
          <v-list-item-title @click="handleNavigation('home')" style="cursor: pointer;">
            <v-img
              src="../assets/logo.png"
              max-width="155"
              height="auto"
              class="mr-2"
            ></v-img>
          </v-list-item-title>
        </v-list-item>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <v-btn
            text
            class="text-subtitle-1 white--text mx-4"
            @click="openM2Website"
          >
            {{ $t("m2_group") }}
          </v-btn>

          <v-btn
            text
            class="text-subtitle-1 white--text mx-4"
            :class="{ active: activeButton === 'solution' || (currentPage === 'home' && activeButton === 'solution') }"
            @click="handleNavigation('solution')"
          >
            {{ $t("solution") }}
          </v-btn>

          <v-btn
            text
            class="text-subtitle-1 white--text mx-4"
            :class="{ active: activeButton === 'about' || (currentPage === 'home' && activeButton === 'about') }"
            @click="handleNavigation('about')"
          >
            {{ $t("about") }}
          </v-btn>

          <v-btn
            text
            class="text-subtitle-1 white--text mx-4"
            :class="{ active: activeButton === 'cases' || (currentPage === 'home' && activeButton === 'cases') }"
            @click="handleNavigation('cases')"
          >
            {{ $t("cases") }}
          </v-btn>

          <v-btn
            text
            class="text-subtitle-1 white--text mx-4"
            :class="{ active: activeButton === 'contact' || (currentPage === 'home' && activeButton === 'contact') }"
            @click="handleNavigation('contact')"
          >
            {{ $t("contact") }}
          </v-btn>

          <v-btn
            text
            class="text-subtitle-1 white--text mx-4"
            :class="{ active: currentPage === 'research' }"
            @click="handleNavigation('research')"
          >
            {{ $t("research") }}
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                class="secondary py-4 mx-4"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="me-1">mdi-web</v-icon>
                {{ language.title }}
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in languageList"
                :key="index"
                @click="$emit('change-language', index)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    language: {
      type: Object,
      required: true
    },
    languageList: {
      type: Array,
      required: true
    },
    activeButton: {
      type: String,
      default: ''
    },
    currentPage: {
      type: String,
      default: 'home'
    }
  },
  methods: {
    openM2Website() {
      window.open('https://m2.m4ore.com', '_blank');
    },
    handleNavigation(target) {
      if (target === 'research') {
        if (this.$route.path !== '/research') {
          this.$router.push('/research').catch(() => {});
        }
      } else if (target === 'home') {
        if (this.$route.path !== '/') {
          this.$router.push('/').catch(() => {});
        }
      } else {
        // For solution, about, cases, contact - scroll to section
        if (this.$route.path !== '/') {
          // 如果不在首頁，導航到首頁並帶上 scrollTo 參數
          const query = { ...this.$route.query, scrollTo: target };
          this.$router.push({ path: '/', query }).catch(() => {});
        } else {
          // 如果已經在首頁，發出滾動事件
          this.$emit('scroll-to-target', target);
        }
      }
    }
  }
}
</script>

<style scoped>
.navbar-class {
  position: fixed;
  width: 100%;
  z-index: 10;
  background-color: #000000;
}

.active {
  padding-top: 5px;
  border-bottom: 2px solid white;
}

/* 直向大螢幕時隱藏桌面版導航，改用手機版 */
@media screen and (orientation: portrait) and (max-width: 1200px) {
  .navbar-class {
    display: none !important;
  }
}
</style>